import CenterSpinner from './CenterSpinner';

export default function FullScreenSpinner() {
  return (
    <div className="w-full h-full fixed block top-0 left-0 bg-white opacity-95 z-60">
      <span className="opacity-95 top-1/2 my-0 mx-auto block relative w-0 h-0">
        <CenterSpinner />
      </span>
    </div>
  );
}
